import { useState } from "react";
import { ArrowUpRight, Check, Instagram, Linkedin, Mail } from "lucide-react";
import axios from "axios";
import { Layout, PageIntro } from "../components/Chrome";
import { Reveal } from "../components/Motion";
import { email, instagram } from "../data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const emptyForm = { name: "", work_email: "", company: "", phone: "", category: "", audience: "", platform: "", creator_requirements: "", timeline: "", budget: "", message: "" };
const fields = [
  ["name", "Name", "text"],
  ["work_email", "Work Email", "email"],
  ["company", "Company / Brand", "text"],
  ["phone", "Phone Number", "tel"],
  ["category", "Campaign Category", "text"],
  ["audience", "Target Audience", "text"],
  ["platform", "Preferred Platform", "text"],
  ["timeline", "Campaign Timeline", "text"],
  ["budget", "Estimated Budget", "text"],
];

export default function Contact() {
  const [form, setForm] = useState(emptyForm);
  const [state, setState] = useState("idle");
  const update = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      await axios.post(`${API}/campaign-brief`, form);
      setState("success");
      setForm(emptyForm);
    } catch {
      setState("error");
    }
  };
  return (
    <Layout>
      <PageIntro
        eyebrow="Start a conversation"
        lines={[<>Let’s build your next</>, <><em>creator campaign.</em></>]}
        text="Tell us what you’re looking to achieve and we’ll help you find the right creators for it."
      />
      <section className="contact-layout section-pad">
        <form className="brief-form" onSubmit={submit} data-testid="campaign-brief-form">
          <div className="form-grid">
            {fields.map(([name, label, type]) => (
              <label key={name}>
                {label}
                <input
                  required={name === "name" || name === "work_email" || name === "company"}
                  name={name}
                  type={type}
                  value={form[name]}
                  onChange={update}
                  data-testid={`brief-${name.replaceAll("_", "-")}`}
                />
              </label>
            ))}
          </div>
          <label>
            Creator Requirements
            <textarea name="creator_requirements" value={form.creator_requirements} onChange={update} data-testid="brief-creator-requirements" />
          </label>
          <label>
            Message
            <textarea name="message" value={form.message} onChange={update} data-testid="brief-message" />
          </label>
          <button type="submit" className="button button-dark submit-button" disabled={state === "loading"} data-testid="submit-campaign-brief">
            <span>{state === "loading" ? "Sending…" : "Submit Campaign Brief"}</span>
            <ArrowUpRight size={15} />
          </button>
          {state === "success" && <p className="form-status success" data-testid="brief-success"><Check size={18} /> Your brief is on its way. We’ll be in touch soon.</p>}
          {state === "error" && <p className="form-status error" data-testid="brief-error">Something went wrong. Please try again.</p>}
        </form>
        <Reveal as="aside" className="contact-aside" delay={0.15}>
          <span className="eyebrow">Moon Media</span>
          <h2>Influencer Marketing<br /><em>& Creator Partnerships</em></h2>
          <div className="contact-details">
            <p>moonmediapartnerships.com</p>
            <a href={`mailto:${email}`} data-testid="contact-email"><Mail size={16} /> {email}</a>
            <a href={instagram} target="_blank" rel="noreferrer" data-testid="contact-instagram"><Instagram size={16} /> Instagram</a>
            <span className="muted-link" data-testid="contact-linkedin"><Linkedin size={16} /> LinkedIn — coming soon</span>
          </div>
        </Reveal>
      </section>
    </Layout>
  );
}
